<div class="content">
    <h2 data-qa="tnb-sub-header">Einstellungen</h2>

    <mat-accordion multi="true">
        <mat-expansion-panel data-qa="kontaktdaten">
            <mat-expansion-panel-header>
                <mat-panel-title>Kontaktdaten</mat-panel-title>
            </mat-expansion-panel-header>
            <redispatch-settings-kontaktdaten></redispatch-settings-kontaktdaten>
        </mat-expansion-panel>
        <mat-expansion-panel data-qa="dienstleistungsarten">
            <mat-expansion-panel-header>
                <mat-panel-title>Dienstleistungsarten</mat-panel-title>
            </mat-expansion-panel-header>
            <redispatch-settings-dienstleistungsarten></redispatch-settings-dienstleistungsarten>
        </mat-expansion-panel>
        <mat-expansion-panel data-qa="dienstleistungsmodule">
            <mat-expansion-panel-header>
                <mat-panel-title>Dienstleistungsmodule</mat-panel-title>
            </mat-expansion-panel-header>
            <redispatch-settings-dienstleistungsmodule></redispatch-settings-dienstleistungsmodule>
        </mat-expansion-panel>
        <mat-expansion-panel data-qa="hilfetexte">
            <mat-expansion-panel-header>
                <mat-panel-title>Hilfetexte</mat-panel-title>
            </mat-expansion-panel-header>
            <redispatch-settings-feldbeschreibung></redispatch-settings-feldbeschreibung>
        </mat-expansion-panel>
        <mat-expansion-panel data-qa="bedienungsanleitung">
            <mat-expansion-panel-header>
                <mat-panel-title>Bedienungsanleitung</mat-panel-title>
            </mat-expansion-panel-header>
            <redispatch-settings-bedienungsanleitung></redispatch-settings-bedienungsanleitung>
        </mat-expansion-panel>
        <mat-expansion-panel data-qa="erzeugungsanlagen-export">
            <mat-expansion-panel-header>
                <mat-panel-title>Erzeugungsanlagen Export</mat-panel-title>
            </mat-expansion-panel-header>
            <redispatch-settings-erzeugnungsanlagen-export></redispatch-settings-erzeugnungsanlagen-export>
        </mat-expansion-panel>
        <mat-expansion-panel data-qa="sst-user">
            <mat-expansion-panel-header>
                <mat-panel-title>Schnittstellen Benutzer</mat-panel-title>
            </mat-expansion-panel-header>
            <redispatch-settings-resource-user></redispatch-settings-resource-user>
        </mat-expansion-panel>
        <mat-expansion-panel data-qa="netzzuordnung-import">
            <mat-expansion-panel-header>
                <mat-panel-title>Netzzuordnung Import</mat-panel-title>
            </mat-expansion-panel-header>
            <redispatch-settings-netzzuordnung-import></redispatch-settings-netzzuordnung-import>
        </mat-expansion-panel>
    </mat-accordion>
</div>

